import { isInViewport } from './modules/util.js';
import { trackLumberjackAndSegment, isMobile } from './segment/segment-utils';
import splitzSetup from './splitz-setup.js';
import lj from './lumberjack';
import { getLjEventProps } from './getLjEventProps';

lj.setupLJ();
let ljproperties = getLjEventProps();

//splitz experiment for x_ca_supporting_text

const SUPPORTING_TEXT_DATA = {
  stage_exp_id: 'I2NbSQTTRjLRYh',
  prod_exp_id: 'I3KFM5LvNLqTLp',
  default_variant: 'x_ca_supporting_text_disabled',
  experiment_variable: 'x_ca_supporting_text_enabled'
};

const STICKY_CTA_DATA = {
  stage_exp_id: 'I8jJmVtc8JRtFW',
  prod_exp_id: 'I8jlEFc0BiT9lv',
  default_variant: 'x_ca_sticky_cta_disabled',
  experiment_variable: 'x_ca_sticky_cta_enabled'
};

const CHATBOT_DATA = {
  stage_exp_id: 'IPor2ijYouR9QU',
  prod_exp_id: 'IRoxdK1Cj4EnHT',
  default_variant: 'x_website_chatbot_disabled',
  experiment_variable: 'x_website_chatbot_enabled'
};

const SOCIAL_PROOF_STRIP_DATA = {
  stage_exp_id: 'IaVB73YcZJecQn',
  prod_exp_id: 'IaVD8LxiUCUgVO',
  default_variant: 'x_ca_social_proof_strip_disabled',
  experiment_variable: 'x_ca_social_proof_strip_enabled'
};

function evaluateExpVariables(resp, EXPERIMENT_DATA) {
  if (resp === EXPERIMENT_DATA['default_variant'] || !resp.variables) {
    return false;
  }
  let respValue = false;
  resp.variables.forEach(element => {
    if (element.key == EXPERIMENT_DATA['experiment_variable'])
      respValue = element.value === 'true';
  });
  return respValue;
}

function evaluateSocialProofStripExp(splitzData) {
  const socialProofStrip = $('.social-strip .container');
  splitzSetup
    .getVariant(
      splitzData.id,
      splitzData.apiBaseUrl,
      splitzData.apiBaseUrl === 'https://api.razorpay.com'
        ? SOCIAL_PROOF_STRIP_DATA['prod_exp_id']
        : SOCIAL_PROOF_STRIP_DATA['stage_exp_id'],
      SOCIAL_PROOF_STRIP_DATA['default_variant']
    )
    .then(resp => {
      if (evaluateExpVariables(resp, SOCIAL_PROOF_STRIP_DATA)) {
        socialProofStrip.removeClass('hide');
        socialProofStrip.attr(
          'data-x-ca-social-proof-strip-variant',
          'enabled'
        );
        lj.pushEvents({
          event_name: 'splitz-variant',
          event_type: 'viewed',
          properties: {
            version: 'variation',
            first_utm: ljproperties.firstUtm,
            last_utm: ljproperties.lastUtm,
            page: 'CA',
            device_type: isMobile() ? 'mweb' : 'dweb'
          }
        });
      } else {
        socialProofStrip.addClass('hide');
        lj.pushEvents({
          event_name: 'splitz-variant',
          event_type: 'viewed',
          properties: {
            version: 'control',
            first_utm: ljproperties.firstUtm,
            last_utm: ljproperties.lastUtm,
            page: 'CA',
            device_type: isMobile() ? 'mweb' : 'dweb'
          }
        });
      }
    });
}

function evaluateSupportingTextExp(splitzData) {
  splitzSetup
    .getVariant(
      splitzData.id,
      splitzData.apiBaseUrl,
      splitzData.apiBaseUrl === 'https://api.razorpay.com'
        ? SUPPORTING_TEXT_DATA['prod_exp_id']
        : SUPPORTING_TEXT_DATA['stage_exp_id'],
      SUPPORTING_TEXT_DATA['default_variant']
    )
    .then(resp => {
      if (evaluateExpVariables(resp, SUPPORTING_TEXT_DATA)) {
        $('.cta-experiment-text').addClass('fade-in');
        $('.cta-experiment-text').attr(
          'data-x-ca-experiment-variant',
          'enabled'
        );
        lj.pushEvents({
          event_name: 'splitz-variant',
          event_type: 'viewed',
          properties: {
            version: 'variation',
            first_utm: ljproperties.firstUtm,
            last_utm: ljproperties.lastUtm,
            device_type: isMobile() ? 'mweb' : 'dweb'
          }
        });
      } else {
        lj.pushEvents({
          event_name: 'splitz-variant',
          event_type: 'viewed',
          properties: {
            version: 'control',
            first_utm: ljproperties.firstUtm,
            last_utm: ljproperties.lastUtm,
            device_type: isMobile() ? 'mweb' : 'dweb'
          }
        });
      }
    });
}

function evaluateStickyCtaExp(splitzData) {
  const signUpPrompt = $('.signup-prompt');
  let signupBannerImpressionRecorded = false;
  splitzSetup
    .getVariant(
      splitzData.id,
      splitzData.apiBaseUrl,
      splitzData.apiBaseUrl === 'https://api.razorpay.com'
        ? STICKY_CTA_DATA['prod_exp_id']
        : STICKY_CTA_DATA['stage_exp_id'],
      STICKY_CTA_DATA['default_variant']
    )
    .then(resp => {
      if (evaluateExpVariables(resp, STICKY_CTA_DATA)) {
        $(document).on('scroll', e => {
          if (canHideSignUpBannerInCaPage()) {
            signUpPrompt.removeClass('static-signup-prompt');
            signUpPrompt.addClass('hide');
            isMobile() &&
              $('#fake-chat-icon-rx').attr('data-x-chatbot-variant') ===
                'enabled' &&
              $('#fake-chat-icon-rx').removeClass('hide');
          } else {
            signUpPrompt.addClass('static-signup-prompt');
            signUpPrompt.removeClass('hide');
            isMobile() &&
              $('#fake-chat-icon-rx').attr('data-x-chatbot-variant') ===
                'enabled' &&
              $('#fake-chat-icon-rx').addClass('hide');
            if (!signupBannerImpressionRecorded) {
              window.rzpAnalytics({
                eventLabel: 'Signup Banner Visible',
                eventAction: 'Signup Banner Visible',
                eventCategory: 'Website - Current Accounts'
              });

              trackLumberjackAndSegment(e, 'Sticky_CTA', '');

              signupBannerImpressionRecorded = true;
            }
          }
        });
        lj.pushEvents({
          event_name: 'Sticky_CTA_lp',
          event_type: 'viewed',
          properties: {
            version: 'variation',
            first_utm: ljproperties.firstUtm,
            last_utm: ljproperties.lastUtm,
            device_type: isMobile() ? 'mweb' : 'dweb'
          }
        });
      } else {
        signUpPrompt.addClass('hide');
        lj.pushEvents({
          event_name: 'Sticky CTA lp',
          event_type: 'viewed',
          properties: {
            version: 'control',
            first_utm: ljproperties.firstUtm,
            last_utm: ljproperties.lastUtm,
            device_type: isMobile() ? 'mweb' : 'dweb'
          }
        });
      }
    });
}

function evaluateChatbotExp(splitzData) {
  splitzSetup
    .getVariant(
      splitzData.id,
      splitzData.apiBaseUrl,
      splitzData.apiBaseUrl === 'https://api.razorpay.com'
        ? CHATBOT_DATA['prod_exp_id']
        : CHATBOT_DATA['stage_exp_id'],
      CHATBOT_DATA['default_variant']
    )
    .then(resp => {
      if (evaluateExpVariables(resp, CHATBOT_DATA)) {
        $('#fake-chat-icon-rx').removeClass('hide');
        $('#fake-chat-icon-rx').attr('data-x-chatbot-variant', 'enabled');
        lj.pushEvents({
          event_name: 'RX_Chatbot_lp',
          event_type: 'viewed',
          properties: {
            version: 'variation',
            first_utm: ljproperties.firstUtm,
            last_utm: ljproperties.lastUtm,
            device_type: isMobile() ? 'mweb' : 'dweb'
          }
        });
      } else {
        lj.pushEvents({
          event_name: 'RX_Chatbot_lp',
          event_type: 'viewed',
          properties: {
            version: 'control',
            first_utm: ljproperties.firstUtm,
            last_utm: ljproperties.lastUtm,
            device_type: isMobile() ? 'mweb' : 'dweb'
          }
        });
      }
    });
}

// const SIGNUP_BANNER_OPTIMISE_ID = 'YTaHndjeRcOyrq7RSUaawg';
// let CAN_SHOW_SIGNUP_BANNER = false;
// window.dataLayer = window.dataLayer || [];
// function gtag() {
//   dataLayer.push(arguments);
// }

// const showSignupBannerVariant = value => {
//   CAN_SHOW_SIGNUP_BANNER = value === 0 ? false : true;
// };

// gtag('event', 'optimize.callback', {
//   name: SIGNUP_BANNER_OPTIMISE_ID,
//   callback: showSignupBannerVariant
// });

const canHideSignUpBannerInCaPage = () => {
  const isBannerSectionVisible = isInViewport(
    '.banner--section .x-btn.btn-icon'
  );
  const isPricingVisibile = isInViewport('.pricing-plan-section');
  const isRazorpayXContentVisible = isInViewport('.screen.screen_9');
  const isFaqVisible = isInViewport('#screen_8');
  const isFooterVisible = isInViewport('footer');
  return (
    isBannerSectionVisible ||
    isPricingVisibile ||
    isRazorpayXContentVisible ||
    isFaqVisible ||
    isFooterVisible
  );
};

$(document).ready(function() {
  let splitzData = splitzSetup.init();
  const signupPromptBtn = $('.signup-prompt-button');
  evaluateSupportingTextExp(splitzData);
  evaluateChatbotExp(splitzData);
  evaluateStickyCtaExp(splitzData);
  evaluateSocialProofStripExp(splitzData);

  signupPromptBtn.on('click', e => {
    window.rzpAnalytics({
      eventLabel: 'Signup',
      eventAction: 'Click - Signup',
      eventCategory: 'Website - Current Accounts'
    });

    trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Sticky CTA');
  });

  //fire event if user scrolls to eligible section for Signup CTA Banner
  let signupBannerElegibleSectionShown = false;
  $(document).on('scroll', e => {
    if (!signupBannerElegibleSectionShown && !canHideSignUpBannerInCaPage()) {
      trackLumberjackAndSegment(e, 'Sticky_CTA_section', '');
      signupBannerElegibleSectionShown = true;
    }
  });
});
